import DropzoneImage from './DropzoneImage'

export default DropzoneImage
